/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <PageHeader {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { graphql } from "gatsby"
import { PageHeader as PageHeaderModule } from "@bw/modules"
import { CmsImage } from "@bw/bits"
import parse from "html-react-parser"

const PageHeader = ({ suptitle, title, subtitle, image, pictogram }) => {
  return (
    <PageHeaderModule
      suptitle={suptitle}
      title={title}
      subtitle={subtitle ? parse(subtitle) : null}
      image={image ? <CmsImage src={image} alt={image.alt} /> : undefined}
      focus={image?.has_focus ? image?.focus_css : undefined}
      pictogram={
        pictogram ? (
          <svg className="icon">
            <use xlinkHref={`/sprite-v2.svg#${pictogram}`} />
          </svg>
        ) : null
      }
    />
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on HeroModule {
 *   ...HeroModuleFragment
 * }
 *
 * This is also what you will get in the props of your LogoGrid
 * resolver component.
 */
export const query = graphql`
  fragment PageHeaderModuleFragment on PageHeaderModule {
    image {
      alt
      has_focus
      focus_css
      localImage {
        childImageSharp {
          gatsbyImageData(width: 1670, quality: 80)
        }
      }
    }
  }
`

export { PageHeader }
